import React from 'react';
import PropTypes from 'prop-types';
import b from 'b_';
import cn from 'classnames';
import './ConsoleFragments.css';

const block = b.lock('ConsoleCardHeader');

export default function ConsoleCardHeader({ className, title, children, ...props }) {
    return <div className={cn(block(), className)} {...props}>
        {title ? <div className={block('Title')}>{title}</div> : null}
        <div className={block('Spacer')} />
        {children}
    </div>;
}

ConsoleCardHeader.propTypes = {
    title: PropTypes.node,
};
